module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page",
    attrs: {
      "id": "dashboard"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel panel--main"
  }, [(_vm.userGroup == 'retailers') ? _c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading tabs__heading"
  }, [_c('span', {
    staticClass: "tab",
    class: {
      active: _vm.retailer.activeChart === 1
    },
    on: {
      "click": function($event) {
        _vm.retailer.activeChart = 1
      }
    }
  }, [_vm._v("Reviews Over Time")]), _c('span', {
    staticClass: "tab",
    class: {
      active: _vm.retailer.activeChart === 2
    },
    on: {
      "click": function($event) {
        _vm.retailer.activeChart = 2
      }
    }
  }, [_vm._v("Rating Over Time")])]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [(_vm.retailer.activeChart === 1) ? _c('line-chart', {
    key: "1",
    attrs: {
      "y-steps-size": 1,
      "plots": _vm.reviewsPerDayPlots(_vm.retailer.recentReviewsPerDay),
      "labels": _vm.reviewsPerDayLabels(_vm.retailer.recentReviewsPerDay)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.retailer.activeChart === 2) ? _c('line-chart', {
    key: "2",
    attrs: {
      "y-steps-size": 1,
      "y-max": 5,
      "plots": _vm.averageRatingPerDayPlots(_vm.retailer.recentAverageRatingPerDay),
      "labels": _vm.averageRatingPerDayLabels(_vm.retailer.recentAverageRatingPerDay)
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "33.333333%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "card reviews-list-small"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Recent Reviews")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('ul', {
    staticClass: "list-bare list-hover card-list card-list--4cards  "
  }, _vm._l((_vm.retailer.recentReviewsData), function(r) {
    return _c('li', {
      staticClass: "card-list__item"
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('review-stars', {
      attrs: {
        "stars": 5,
        "active": r.overallRating
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('p', [_vm._v(_vm._s(r.washroom.humanId))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('p', [_vm._v(_vm._s(_vm.timestampToDateShort(r.createdAt)))])])])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total 1 Star Ratings',
      "value": '#'
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'New 1 Star Ratings',
      "value": '#'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total 5 Star Ratings',
      "value": '#'
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'New 5 Star Ratings',
      "value": '#'
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "33%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Reviews',
      "value": _vm.retailer.totalReviews
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Recent Reviews',
      "value": _vm.retailer.recentReviews
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Issues',
      "value": _vm.retailer.totalIssues
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Recent Issues',
      "value": _vm.retailer.recentIssues
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('percentage-card-contents', {
    attrs: {
      "heading": 'Total Open Issues',
      "percentage": _vm.retailerTotalOpenIssuesPercentage,
      "count": _vm.retailer.totalOpenIssues
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('percentage-card-contents', {
    attrs: {
      "heading": 'Total Closed Issues',
      "percentage": _vm.retailerTotalClosedIssuesPercentage,
      "count": _vm.retailer.totalClosedIssues
    }
  })], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'multi-site-retailers') ? _c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading tabs__heading"
  }, [_c('span', {
    staticClass: "tab",
    class: {
      active: _vm.multisite.activeChart === 1
    },
    on: {
      "click": function($event) {
        _vm.multisite.activeChart = 1
      }
    }
  }, [_vm._v("Reviews Over Time")]), _c('span', {
    staticClass: "tab",
    class: {
      active: _vm.multisite.activeChart === 2
    },
    on: {
      "click": function($event) {
        _vm.multisite.activeChart = 2
      }
    }
  }, [_vm._v("Rating Over Time")])]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [(_vm.multisite.activeChart === 1) ? _c('line-chart', {
    key: "1",
    attrs: {
      "y-steps-size": 1,
      "plots": _vm.reviewsPerDayPlots(_vm.multisite.recentReviewsPerDay),
      "labels": _vm.reviewsPerDayLabels(_vm.multisite.recentReviewsPerDay)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.multisite.activeChart === 2) ? _c('line-chart', {
    key: "2",
    attrs: {
      "y-steps-size": 1,
      "y-max": 5,
      "plots": _vm.averageRatingPerDayPlots(_vm.multisite.recentAverageRatingPerDay),
      "labels": _vm.averageRatingPerDayLabels(_vm.multisite.recentAverageRatingPerDay)
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "33.333333%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "card reviews-list-small"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Recent Reviews")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('ul', {
    staticClass: "list-bare list-hover card-list card-list--4cards  "
  }, _vm._l((_vm.multisite.recentReviewsData), function(r) {
    return _c('li', {
      staticClass: "card-list__item"
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('review-stars', {
      attrs: {
        "stars": 5,
        "active": r.overallRating
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('p', [_vm._v(_vm._s(r.washroom.humanId))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('p', [_vm._v(_vm._s(_vm.timestampToDateShort(r.createdAt)))])])])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total 1 Star Ratings',
      "value": '#'
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'New 1 Star Ratings',
      "value": '#'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total 5 Star Ratings',
      "value": '#'
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'New 5 Star Ratings',
      "value": '#'
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "33%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Retailers',
      "comment": "All time",
      "value": _vm.multisite.totalRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'New Retailers',
      "comment": "Last 7 days",
      "value": _vm.multisite.newRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total Reviews',
      "value": _vm.multisite.totalReviews
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'Recent Reviews',
      "value": _vm.multisite.recentReviews
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total Issues',
      "value": _vm.multisite.totalIssues
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'Recent Issues',
      "value": _vm.multisite.recentIssues
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('percentage-card-contents', {
    attrs: {
      "heading": 'Total Open Issues',
      "percentage": _vm.multisiteTotalOpenIssuesPercentage,
      "count": _vm.multisite.totalOpenIssues
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('percentage-card-contents', {
    attrs: {
      "heading": 'Total Closed Issues',
      "percentage": _vm.multisiteTotalClosedIssuesPercentage,
      "count": _vm.multisite.totalClosedIssues
    }
  })], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'service-providers') ? _c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading tabs__heading"
  }, [_c('span', {
    staticClass: "tab",
    class: {
      active: _vm.serviceProvider.activeChart === 1
    },
    on: {
      "click": function($event) {
        _vm.serviceProvider.activeChart = 1
      }
    }
  }, [_vm._v("Reviews Over Time")]), _c('span', {
    staticClass: "tab",
    class: {
      active: _vm.serviceProvider.activeChart === 2
    },
    on: {
      "click": function($event) {
        _vm.serviceProvider.activeChart = 2
      }
    }
  }, [_vm._v("Rating Over Time")])]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [(_vm.serviceProvider.activeChart === 1) ? _c('line-chart', {
    key: "1",
    attrs: {
      "y-steps-size": 1,
      "plots": _vm.reviewsPerDayPlots(_vm.serviceProvider.recentReviewsPerDay),
      "labels": _vm.reviewsPerDayLabels(_vm.serviceProvider.recentReviewsPerDay)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.serviceProvider.activeChart === 2) ? _c('line-chart', {
    key: "2",
    attrs: {
      "y-steps-size": 1,
      "y-max": 5,
      "plots": _vm.averageRatingPerDayPlots(_vm.serviceProvider.recentAverageRatingPerDay),
      "labels": _vm.averageRatingPerDayLabels(_vm.serviceProvider.recentAverageRatingPerDay)
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "33.333333%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "card reviews-list-small"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Recent Reviews")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('ul', {
    staticClass: "list-bare list-hover card-list card-list--4cards  "
  }, _vm._l((_vm.serviceProvider.recentReviewsData), function(r, index) {
    return (index < 4) ? _c('li', {
      staticClass: "card-list__item"
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('review-stars', {
      attrs: {
        "stars": 5,
        "active": r.overallRating
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('p', [_vm._v(_vm._s(r.washroom.humanId))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('p', [_vm._v(_vm._s(_vm.timestampToDateShort(r.createdAt)))])])])])]) : _vm._e()
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'New 1 Star Ratings',
      "value": '#'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'New 5 Star Ratings',
      "value": '#'
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "33%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total Retailers',
      "value": _vm.serviceProvider.totalRetailers
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'Recent Retailers',
      "value": _vm.serviceProvider.recentRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total Multisite Retailers',
      "value": _vm.serviceProvider.totalMultisiteRetailers
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'Recent Multisite Retailers',
      "value": _vm.serviceProvider.recentMultisiteRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total Reviews',
      "value": _vm.serviceProvider.totalReviews
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'Recent Reviews',
      "value": _vm.serviceProvider.recentReviews
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Issues',
      "value": _vm.serviceProvider.totalIssues
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('percentage-card-contents', {
    attrs: {
      "heading": 'Total Open Issues',
      "percentage": _vm.serviceProviderTotalOpenIssuesPercentage,
      "count": _vm.serviceProvider.totalOpenIssues
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('percentage-card-contents', {
    attrs: {
      "heading": 'Total Closed Issues',
      "percentage": _vm.serviceProviderTotalClosedIssuesPercentage,
      "count": _vm.serviceProvider.totalClosedIssues
    }
  })], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins') ? _c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading tabs__heading"
  }, [_c('span', {
    staticClass: "tab",
    class: {
      active: _vm.hsgadmin.activeChart === 1
    },
    on: {
      "click": function($event) {
        _vm.hsgadmin.activeChart = 1
      }
    }
  }, [_vm._v("Reviews Over Time")]), _c('span', {
    staticClass: "tab",
    class: {
      active: _vm.hsgadmin.activeChart === 2
    },
    on: {
      "click": function($event) {
        _vm.hsgadmin.activeChart = 2
      }
    }
  }, [_vm._v("Daily App Downloads")])]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [(_vm.hsgadmin.activeChart === 1) ? _c('line-chart', {
    key: "1",
    attrs: {
      "y-steps-size": 1,
      "plots": _vm.reviewsPerDayPlots(_vm.hsgadmin.recentReviewsPerDay),
      "labels": _vm.reviewsPerDayLabels(_vm.hsgadmin.recentReviewsPerDay)
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "33.333333%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total App Downloads',
      "comment": "",
      "value": '#'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'New App Downloads',
      "comment": "",
      "value": '#'
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Reviews',
      "comment": "",
      "value": _vm.hsgadmin.totalReviews
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Issues',
      "comment": "",
      "value": _vm.hsgadmin.totalIssues
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "33%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Retailers',
      "comment": "All time",
      "value": _vm.hsgadmin.totalRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'New Retailers',
      "comment": "Last 7 days",
      "value": _vm.hsgadmin.newRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Multisites',
      "comment": "All time",
      "value": _vm.hsgadmin.totalMultisiteRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'New Multisites',
      "comment": "Last 7 days",
      "value": _vm.hsgadmin.newMultisiteRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Service Providers',
      "comment": "All time",
      "value": _vm.hsgadmin.totalServiceProviders
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'New Service Providers',
      "comment": "Last 7 days",
      "value": _vm.hsgadmin.newServiceProviders
    }
  })], 1)])])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel--header"
  }, [_c('h1', [_vm._v("Dashboard")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c6cadd3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Dashboard/Dashboard.vue
// module id = 552
// module chunks = 1